import React from 'react';
import { ButtonSearch } from '../styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory, useRouteMatch } from 'react-router';
import { useTranslate } from 'react-translate';

function HelpButton() {
  const t = useTranslate('Header');
  const { params } = useRouteMatch();
  const history = useHistory();

  function handleHelpButtonClick() {
    history.push(`/${params.code}/ContactUs`);
  }

  return (
    <ButtonSearch id="helpButton" onClick={handleHelpButtonClick}>
      <FontAwesomeIcon icon={['fal', 'life-ring']} />
      <p>{t('HELP')}</p>
    </ButtonSearch>
  );
}

export default HelpButton;
